import { DASHBOARDS_PAGE_KEY } from './constants';

export const es = {
  [DASHBOARDS_PAGE_KEY]: {
    // Page header
    PAGE_TITLE: 'Dashboards',
    PAGE_SUBTITLE:
      'Visualiza el pulso general de tu organización en los principales módulos activos.',
    // Header actions
    FRESHNESS_PREFIX: 'Última actualización:',
    FRESHNESS_REFRESH_LABEL: 'Actualizar dashboard',

    // Breadcrumbs
    BREADCRUMB_1: 'Analítica',
    BREADCRUMB_2: 'Estadísticas',
    BREADCRUMB_3: 'Dashboards',

    // Section tags
    SECTION_A_PERIOD_TAG: 'Últimos 30 días',
    SECTION_C_PERIOD_TAG: 'Mes actual',
    SECTION_C_PERIOD_TOOLTIP:
      'Actividad del mes en curso, contabilizada desde el primer día del mes hasta hoy. No representa los últimos 30 días calendario.',

    // Section headings
    SECTION_A_HEADING: 'Métricas claves',
    SECTION_B_HEADING: 'Tendencias',
    SECTION_C_HEADING: 'Pulso por módulo',
    SECTION_D_HEADING: 'Acciones recomendadas',
    SECTION_E_HEADING: 'Highlights del mes',

    // Sections
    SECTION_PLACEHOLDER: 'Contenido próximamente',

    // Section A — KPI cards
    SECTION_A_CARD_1_DESC: 'Colaboradores activos',
    SECTION_A_CARD_1_HELP:
      'Colaboradores con estado activo en tu organización (sin fecha de salida). Fuente: Gestión / HRIS centralizada. El sparkline muestra las activaciones diarias de los últimos 30 días y el delta compara la última semana vs la anterior.',
    SECTION_A_CARD_2_DESC: '% Colaboradores con login últimos 30 días',
    SECTION_A_CARD_2_HELP:
      'Porcentaje de colaboradores activos que iniciaron sesión al menos una vez en los últimos 30 días. Es el proxy de adopción real de la plataforma. El delta compara contra el mismo cálculo del mes anterior.',
    SECTION_A_CARD_3_DESC: 'Crecimiento headcount últimos 3 meses',
    SECTION_A_CARD_3_HELP:
      'Diferencia neta de colaboradores: headcount actual vs hace 3 meses (altas menos bajas). El sparkline muestra las activaciones mensuales de los últimos 12 meses. Fuente: HRIS Centralizada.',

    // Section B — Trend cards
    SECTION_B_CARD_1_TITLE: 'Actividad de la plataforma',
    SECTION_B_CARD_1_DESC:
      'Usuarios únicos por día · Login events (Centralizada)',
    SECTION_B_CARD_1_HELP:
      'Usuarios únicos que iniciaron sesión cada día (eventos de login · Centralizada). Compara el período actual contra el anterior; los días sin actividad cuentan como 0. Promedio, pico y mínimo se calculan sobre el período actual.',
    SECTION_B_CARD_2_TITLE: 'Composición de actividad',
    SECTION_B_CARD_2_DESC: 'Acciones por módulo · delta vs mes anterior',
    SECTION_B_CARD_2_HELP:
      'Acciones registradas por cada módulo durante el período, con su variación vs el período anterior. Cada barra se calcula de forma independiente con los datos de actividad de su propio módulo.',
    SECTION_B_MONTH_FILTER: 'Mayo 2026',

    // Section C — Module cards
    SECTION_C_MODULE_LEARNING: 'Aprendizaje',
    SECTION_C_MODULE_TALENT: 'Talent',
    SECTION_C_MODULE_RECRUITMENT: 'Reclutamiento',
    SECTION_C_MODULE_COMMUNICATIONS: 'Comunicaciones',
    SECTION_C_MODULE_LEARNING_HELP:
      'Avance global = progreso promedio de los cursos asignados. Cursos completados suma catálogo propio + Crehana en el mes. Satisfacción = promedio (1–5) de las encuestas de fin de curso del período. Misma fuente que los reportes centralizados.',
    SECTION_C_MODULE_TALENT_HELP:
      'Procesos activos = todos los procesos en curso o iniciados (Competencias, Metas, Clima, OKRs y PID), sin importar cuándo se crearon. Feedbacks = realizados durante el período.',
    SECTION_C_MODULE_RECRUITMENT_HELP:
      'Vacantes abiertas = vacantes publicadas actualmente. Candidatos en proceso = postulantes únicos por vacante (no se duplican por reclutador).',
    SECTION_C_MODULE_COMMUNICATIONS_HELP:
      'Actividad mensual del módulo de Comunicaciones: publicaciones del período e interacciones (reacciones + comentarios).',

    // Section D — Recommended actions
    SECTION_D_ALERTS_TITLE: 'Alertas que necesitan atención',
    SECTION_D_ALERTS_HELP:
      'Conteos accionables calculados en vivo y ordenados por severidad: cursos obligatorios vencidos o próximos a vencer con avance bajo, evaluaciones con baja participación o pendientes de cierre por líder, asignaciones sin inicio (+14 días), vacaciones pendientes y reportes programados próximos a ejecutarse.',
    SECTION_D_FILTER_ALL: 'Todas',

    // Section E — Highlight cards
    SECTION_E_CARD_1_TITLE: 'Top 5 cursos más completados',
    SECTION_E_CARD_1_DESC: 'Este mes · 14 abr – 14 may',
    SECTION_E_CARD_1_HELP:
      'Completado = el colaborador terminó el 100% de los módulos del curso en el período. Las horas reflejan reproducción real (minutos de progreso), no la duración del curso. Para certificación final, ver el hito Certificados emitidos.',
    SECTION_E_CARD_2_TITLE: 'Áreas con más colaboradores activos',
    SECTION_E_CARD_2_DESC: '% de colab con login últimos 30 días · Este mes',
    SECTION_E_CARD_2_HELP:
      'Porcentaje de colaboradores de cada área con al menos un login en los últimos 30 días, ordenado de mayor a menor adopción. Usa el mismo cálculo que el KPI de login de la parte superior, segmentado por área.',
    SECTION_E_CARD_3_TITLE: 'Hitos alcanzados este mes',
    SECTION_E_CARD_3_DESC: 'Logros del periodo 14 abr – 14 may',
    SECTION_E_CARD_3_HELP:
      'Logros del período comparados contra el mes anterior: horas de estudio, certificados emitidos, procesos de evaluación cerrados, PIDs generados y nuevas licencias activadas.',

    // Empty state
    EMPTY_TITLE: 'Aún no tienes módulos que mostrar',
    EMPTY_CTA: 'Contactar a ventas',

    // Error state
    ERROR_BANNER: 'No pudimos cargar el dashboard.',
    ERROR_RETRY: 'Reintentar',

    // Recommended actions states
    RECOMMENDED_EMPTY: 'No hay acciones recomendadas por ahora.',
    RECOMMENDED_NO_ALERTS: 'No tienes alertas pendientes',
    RECOMMENDED_ERROR: 'No pudimos cargar las acciones recomendadas.',

    // Recommended actions — alert titles
    ALERT_OVERDUE_COURSES_TITLE: 'Cursos obligatorios vencidos',
    ALERT_EXPIRING_COURSES_TITLE:
      'Cursos obligatorios próximos a vencer con avance bajo',
    ALERT_LOW_EVAL_PARTICIPATION_TITLE:
      'Procesos de evaluación con baja participación',
    ALERT_PENDING_CALIBRATION_TITLE:
      'Evaluaciones pendientes de cierre por líder',
    ALERT_UNSTARTED_PATHS_TITLE:
      'Rutas/cursos asignados sin inicio (más de 14 días)',
    ALERT_LEADERS_NO_EVAL_TITLE: 'Líderes con teams sin evaluar este ciclo',
    ALERT_PENDING_VACATIONS_TITLE:
      'Solicitudes de vacaciones pendientes por aprobar',
    ALERT_UPCOMING_REPORTS_TITLE: 'Reportes programados próximos a ejecutarse',

    // Recommended actions — alert sublabels ({{count}} interpolated)
    ALERT_OVERDUE_COURSES_SUBLABEL:
      '{{count}} colaboradores con cursos obligatorios fuera de plazo · Impacto en compliance',
    ALERT_EXPIRING_COURSES_SUBLABEL:
      '{{count}} colaboradores tienen cursos obligatorios que vencen en menos de 7 días con avance menor a 50% · Tiempo de actuar',
    ALERT_LOW_EVAL_PARTICIPATION_SUBLABEL:
      '{{count}} procesos de Q2 con menos de 50% de respuesta a 7 días del cierre · Performance + Clima',
    ALERT_PENDING_CALIBRATION_SUBLABEL:
      '{{count}} evaluaciones esperando calibración final del líder · 6 días para cierre del trimestre',
    ALERT_UNSTARTED_PATHS_SUBLABEL:
      '{{count}} colaboradores con rutas asignadas que no han iniciado · Considera reactivar',
    ALERT_LEADERS_NO_EVAL_SUBLABEL:
      '{{count}} líderes sin enviar evaluaciones de su equipo · Sigue pendiente del ciclo Q2',
    ALERT_PENDING_VACATIONS_SUBLABEL:
      '{{count}} solicitudes en tu org · Aprobación de líderes (solo visibilidad)',
    ALERT_UPCOMING_REPORTS_SUBLABEL:
      '{{count}} reportes se ejecutan en las próximas 24h · Revisa destinatarios y filtros',

    // Permission
    TOAST_NO_PERMISSION: 'No tienes permisos para ver Dashboards',

    // CTA strip
    CTA_TITLE: '¿Quieres ir más profundo?',
    CTA_SUBTITLE:
      'Genera un reporte personalizado desde Seguimientos en Reportería.',
    CTA_BUTTON: 'Crear reporte personalizado',

    // KPI card body
    KPI_DELTA_WOW: 'vs semana anterior',
    KPI_DELTA_MOM: 'vs mes anterior',
    KPI_DELTA_NET: 'neto últimos 3 meses',
    KPI_NET_LABEL: 'colaboradores netos',
    KPI_ERROR: 'No pudimos cargar esta métrica.',
    KPI_SPARKLINE_A11Y: 'Tendencia de los últimos 30 días',

    // Activity composition card (ANLT-168)
    // title + subtitle son BE-authoritatives (vienen en response.title / response.subtitle)
    ACTIVITY_COMPOSITION_LOADING_LABEL: 'Cargando composición de actividad',
    ACTIVITY_COMPOSITION_ERROR:
      'No pudimos cargar la composición de actividad.',
    ACTIVITY_COMPOSITION_RETRY: 'Reintentar',
    ACTIVITY_COMPOSITION_EMPTY: 'Sin módulos adicionales contratados',
    ACTIVITY_COMPOSITION_SUBHEADING: 'Acciones de alto volumen',

    // Module pulse card footer
    MODULE_VER_DETALLE: 'Ver detalle',

    // Activity chart series
    ACTIVITY_SERIES_CURRENT: 'Mes actual',
    ACTIVITY_SERIES_PREVIOUS: 'Mes anterior',

    // Activity stats bar
    ACTIVITY_STAT_AVG: 'Promedio',
    ACTIVITY_STAT_AVG_UNIT: 'usuarios/día',
    ACTIVITY_STAT_PEAK: 'Pico',
    ACTIVITY_STAT_MIN: 'Mínimo',
    ACTIVITY_DELTA_LABEL: 'vs mes anterior',

    // Top courses ranking — metrics (completions + avg hours formatted in FE)
    TOP_COURSES_COMPLETED: '{{count}} completados',
    TOP_COURSES_AVG_HOURS: '{{hours}} h promedio',
    // Top courses ranking — states
    TOP_COURSES_TOOLTIP:
      'Completado = colaborador finalizó el 100% de módulos del curso',
    TOP_COURSES_EMPTY: 'Aún no hay cursos completados este mes',
    TOP_COURSES_ERROR: 'No pudimos cargar el ranking de cursos',
    TOP_COURSES_RETRY: 'Reintentar',

    // Areas engagement bars — states
    AREAS_ENGAGEMENT_EMPTY: 'Aún no hay datos de actividad por área',
    AREAS_ENGAGEMENT_ERROR: 'No pudimos cargar la actividad por área',
    AREAS_ENGAGEMENT_RETRY: 'Reintentar',

    // Tooltip accessibility
    HELP_TOOLTIP_LABEL: 'Más información',

    // Section E — Milestones
    MILESTONES_TITLE: 'Hitos alcanzados este mes',
    MILESTONES_PERIOD: 'Logros del periodo 14 abr – 14 may',
    MILESTONE_STUDY_HOURS: 'horas de estudio completadas',
    MILESTONE_CERTIFICATIONS: 'certificados emitidos',
    MILESTONE_TALENT_PROCESSES: 'procesos de evaluación cerrados',
    MILESTONE_PIDS: 'PIDs generados',
    MILESTONE_LICENSES: 'nuevas licencias activadas',
    MILESTONES_ERROR: 'No pudimos cargar los hitos.',
    MILESTONES_RETRY: 'Reintentar',
  },
};
